// `env` injected via webpack. Will break portal however, since this file is imported without the context of webpack. Thus, `try-catch`
let environment;
try {
  environment = env
} catch (e) {
  environment = { PRODUCTION: true }
};

export const MMS_ORIGIN = environment.PRODUCTION
  ? 'https://mms.sp-prod.net/mms/v2'
  : 'https://mms.sp-stage.net/mms/v2';

export const CCPA_ORIGIN = environment.PRODUCTION
  ? 'https://ccpa-service.sp-prod.net'
  : 'https://ccpa.sp-stage.net';

export const ccpaRoutes = {
  DELETE: 'delete-my-data',
  DSAR: 'dsar',
}

export const sarViews = {
  FORM: 'form',
  SUCCESS: 'success',
  error: {
    VERIFICATION: 'verification',
    MAX_REQUESTS: 'max-requests',
    ACTIVE_REQUEST: 'active-request'
  }
};

export const dsarRetrievalViews = {
  HOME: 'home',
  ONE_TIME_CODE: 'one-time-code',
  CODE_SUCCESS: 'code-success',
  REQUEST_PENDING: 'request-pending',
}

export const VERIFICATION_FAILURE = 'VERIFICATION_FAILURE';
export const MAX_REQUESTS_EXCEEDED = 'MAX_REQUESTS_EXCEEDED';
export const MISMATCH = 'MFA_CODE_FAILURE';
export const PROCESSING_REQUEST = 'PROCESSING_REQUEST';